import { getAxiosClient } from './common';

const axios = getAxiosClient();

// Mirrors the server's ProjectHistoryEvent (packages/api/src/controllers/projectAgencyHistory.ts) —
// keep in sync; there is no shared type boundary between client and api.

export type AgencyHistoryChangeType = 'added' | 'removed' | 'modified';

export type AgencyHistoryChange = {
  agencyId: string;
  // null when the agency row was hard-deleted after the change was logged.
  agencyName: string | null;
  // agencies.type ('water', 'sewer', …) — what tells two same-named city agencies apart. Null for
  // a hard-deleted agency.
  agencyType: string | null;
  changeType: AgencyHistoryChangeType;
  changedFields: string[];
  assetsInProjectArea: boolean;
  // How many connectbase building locations the row held — the points themselves are not logged.
  buildingLocationCount: number;
};

/** One update: every agency change captured by a single sync, recompute, merge, or archive. */
export type ProjectHistoryEvent = {
  id: string;
  // Why the update ran (e.g. 'manualRecompute', 'backfill'); stored as free text server-side, so
  // treat unknown values as displayable rather than exhaustively matching them.
  reason: string;
  createdAt: string;
  counts: { added: number; removed: number; modified: number };
  changes: AgencyHistoryChange[];
};

export type ProjectAgencyHistoryResponse = { events: ProjectHistoryEvent[] };

export function projectAgencyHistoryQueryKey(projectId: string) {
  return ['project-agency-history', { projectId }] as const;
}

export async function fetchProjectAgencyHistory(projectId: string): Promise<ProjectAgencyHistoryResponse> {
  const { data } = await axios({
    method: 'GET',
    url: `/v3/projects/${projectId}/agency-history`,
  });
  return data;
}
